module.exports = __webpack_public_path__ + "img/uploader-default.317a9099.svg";